import {useState} from "react";

const FAQ = () => {
    const faqItems = [
        {
            question: "چگونه تبلیغات خود را مدیریت کنم؟",
            answer:
                "تیم ما گزارش‌های دوره‌ای جامع از عملکرد کمپین‌های شما ارائه می‌دهد تا بتوانید نتایج را بررسی و در صورت نیاز، استراتژی‌های تبلیغاتی خود را بهینه کنید."
        },
        // {
        //     question: "بازاریابی مجدد دیجیتال چگونه عمل می‌کند و چه اطلاعاتی مورد نیاز است؟",
        //     answer:
        //         "بازاریابی مجدد دیجیتال از طریق استفاده از کوکی‌ها و پیکسل‌های ردیابی، کاربران قبلی که از سایت یا محتواهای شما بازدید کرده‌اند را شناسایی کرده و به آن‌ها تبلیغات هدفمند ارائه می‌دهد. معمولاً برای این منظور به اطلاعاتی مانند تاریخچه بازدید و برخی داده‌های جمعیتی نیاز است."
        // },
        {
            question: "کمپین تبلیغاتی را در کدام شهر ها می‌توان اجرا کرد؟",
            answer:
                "در حال حاضر، کمپین‌های تبلیغاتی ما فقط در شهر شیراز اجرا می‌شوند. با تمرکز بر این شهر، از رسانه‌های شهری و تبلیغات محیطی بهره می‌بریم تا به بهترین نحو به مخاطبان محلی دست یابیم."
        },
        {
            question: "چگونه انسجام طراحی را در مدل‌های مختلف خودرو حفظ می‌کنید؟",
            answer:
                "ما با استفاده از قالب‌های طراحی انعطاف‌پذیر که به راحتی برای اندازه‌های مختلف خودرو قابل تنظیم هستند، انسجام طراحی را حفظ می‌کنیم. تیم خلاق ما همراه با کارشناسان فنی، اطمینان حاصل می‌کنند که هر طرح مطابق با هویت برند و ابعاد خاص هر خودرو باشد."
        },
        // {
        //   question: "آیا کمپین شامل تولید، رسانه و نصب نیز می‌شود؟",
        //   answer:
        //     "بله، کمپین‌های ما یک بسته جامع هستند که شامل تولید محتوا، برنامه‌ریزی و خرید رسانه، و نصب تبلیغات می‌باشند. ما از ابتدا تا انتهای کمپین را در کنار شما هستیم."
        // },
        {
            question: "آیا می‌توانم راننده باشم؟",
            answer:
                "بله، اگر علاقه‌مند به همکاری به عنوان راننده در کمپین‌های تبلیغاتی ما هستید، لطفاً با ما تماس بگیرید تا اطلاعات لازم درباره شرایط و فرایند درخواست در اختیار شما قرار گیرد."
        }
    ];

    return (
        <section className="mt-14 py-20 bg-gray-50">
            <div className="container mx-auto px-4 pb-32">
                <h2 className="text-4xl font-bold text-center mb-10 text-gray-800">
                    سوالات متداول
                </h2>
                <div className="max-w-3xl mx-auto">
                    {faqItems.map((item, index) => (
                        <FaqItem key={index} question={item.question} answer={item.answer}/>
                    ))}
                </div>
            </div>
        </section>
    );
};

const FaqItem = ({question, answer}) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="border-b border-gray-200 py-4">
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="w-full flex justify-between items-center focus:outline-none"
            >
                <span className="text-xl font-medium text-gray-800">{question}</span>
                <svg
                    className={`w-6 h-6 transform transition-transform duration-300 ${
                        isOpen ? "rotate-180" : ""
                    }`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M19 9l-7 7-7-7"
                    ></path>
                </svg>
            </button>
            {isOpen && (
                <p className="mt-3 text-gray-600 leading-relaxed">{answer}</p>
            )}
        </div>
    );
};

export default FAQ;
